import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {TextInput} from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import AppCredential from '../AppCredential/AppCredential';
import {useRecoilState} from "recoil";
import {activeAutom} from "../../../../recoil-store/recoil-state";
import {Checkboxes} from "../../../FlowConfigurationInputs";

function Text({action, variables, setOpenVariable, automId, showAlert, automVersionId, automaticallyWhatsappVariableCreation}) {
    const {t} = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WHATSAPP.TEXT.';

    const [isQuestion, setIsQuestion] = useState(false);
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);


    const updateLabel = (id, items) => {
        items.forEach(item => {
            if (item.id === id) {
                item.fields = action.fields;
            } else if (item.children) {
                updateLabel(id, item.children);
            }
        });
    };

    const handleBlur = () => {
        let fields = action.fields;
        let items = JSON.parse(JSON.stringify(automDetail.items));
        action.fields = JSON.parse(JSON.stringify(fields));
        updateLabel(action.id, items);
        setAutomDetail({...automDetail, items: JSON.parse(JSON.stringify(items))});
    };

    const changeIsQuestion = (status) => {
        setIsQuestion(status);
        if (status) {
            const variableName = `##${action.actionName.toLowerCase()}_${action.item_id.replaceAll('-', '')}##`
            automaticallyWhatsappVariableCreation(action.item_id, action.actionName)

            action.fields.set = {
                conditions: [],
                value: variableName
            }
        } else {
            // TODO delete variable action here
        }

    }


    return (
        <div>
            <AppCredential action={action}/>
            <div className="form-element">
                {t(label + "LABEL")}
                <TextInput
                    action={action}
                    inputName="label"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    onBlur={handleBlur}
                    fieldType="string" 
                    displayName={t(label + "LABEL")}
                />
            </div>
            <div className="form-element">
                {t(label + 'MESSAGE')}
                <TextInput action={action} inputName="message" variables={variables}
                           setOpenVariable={setOpenVariable} multiline rows={4}  fieldType="string" displayName={t(label + 'MESSAGE')}/>
            </div>
            <div className="form-element">
                <Checkboxes
                    action={action}
                    itemtype="app_connector"
                    inputName="isQuestion"
                    onChange={() => changeIsQuestion(!isQuestion)}
                    options={{label: label + "IS-QUESTION"}}
                    isRequired={false}
                />
            </div>
            {isQuestion && (
                <div className="form-element">
                    {t(label + 'RESPONSE')}
                    <TextInput action={action} inputName="set" variables={variables} disabled={true}
                               setOpenVariable={setOpenVariable} rows={4} fieldType="string"  displayName= {t(label + 'RESPONSE')}/>
                </div>
                )}
        </div>
    );
}

export default Text;
